export const TOGGLE_LABEL_QUE = 'TOGGLE_LABEL_QUE';
export const toggleLabelQue = (isOpen) => ({
  type: TOGGLE_LABEL_QUE,
  isOpen,
});

export const LABEL_QUE_GET_BATCHES_REQUEST = 'LABEL_QUE_GET_BATCHES_REQUEST';
export const getLabelQueBatchesRequest = (labelBatchUserId) => ({
  type: LABEL_QUE_GET_BATCHES_REQUEST,
  labelBatchUserId,
});

export const GET_LABEL_QUE_BATCHES_SUCCESS = 'GET_LABEL_QUE_BATCHES_SUCCESS';
export const getLabelQueBatchesSuccess = (batches) => ({
  type: GET_LABEL_QUE_BATCHES_SUCCESS,
  batches,
});

export const GET_LABEL_QUE_BATCHES_FAILURE = 'GET_LABEL_QUE_BATCHES_FAILURE';
export const getLabelQueBatchesFailure = (error) => ({
  type: GET_LABEL_QUE_BATCHES_FAILURE,
  error,
});

export const SET_LABEL_QUE_BATCH_SELECTED = 'SET_LABEL_QUE_BATCH_SELECTED';
export const setLabelQueBatchSelected = (batchId) => ({
  type: SET_LABEL_QUE_BATCH_SELECTED,
  batchId,
});

export const SELECT_ALL_LABEL_QUE_BATCHES = 'SELECT_ALL_LABEL_QUE_BATCHES';
export const selectAllLabelQueBatches = () => ({
  type: SELECT_ALL_LABEL_QUE_BATCHES,
});

export const DESELECT_ALL_LABEL_QUE_BATCHES = 'DESELECT_ALL_LABEL_QUE_BATCHES';
export const deSelectAllLabelQueBatches = () => ({
  type: DESELECT_ALL_LABEL_QUE_BATCHES,
});

export const ADD_LABEL_BATCH_TO_LABEL_QUE = 'ADD_LABEL_BATCH_TO_LABEL_QUE';
export const addLabelBatchToLabelQue = (labelQueBatch) => ({
  type: ADD_LABEL_BATCH_TO_LABEL_QUE,
  labelQueBatch,
});

export const LOAD_MORE_LABEL_QUE_BATCHES = 'LOAD_MORE_LABEL_QUE_BATCHES';
export const loadMoreLabelQueBatches = () => ({
  type: LOAD_MORE_LABEL_QUE_BATCHES,
});

export const LABEL_QUE_PRINT_LABEL_START = 'LABEL_QUE_PRINT_LABEL_START';
export const labelQuePrintLabelStart = (batchId) => ({
  type: LABEL_QUE_PRINT_LABEL_START,
  batchId,
});

export const LABEL_QUE_ARCHIVE_BATCHES_REQUEST = 'LABEL_QUE_ARCHIVE_BATCHES_REQUEST';
export const labelQueArchiveBatches = (batchIds) => ({
  type: LABEL_QUE_ARCHIVE_BATCHES_REQUEST,
  batchIds,
});

export const LABEL_QUE_ARCHIVE_BATCHES_SUCCESS = 'LABEL_QUE_ARCHIVE_BATCHES_SUCCESS';
export const labelQueArchiveBatchesSuccess = () => ({
  type: LABEL_QUE_ARCHIVE_BATCHES_SUCCESS,
});

export const LABEL_QUE_ARCHIVE_BATCHES_FAILURE = 'LABEL_QUE_ARCHIVE_BATCHES_FAILURE';
export const labelQueArchiveBatchesFailure = (error) => ({
  type: LABEL_QUE_ARCHIVE_BATCHES_FAILURE,
  error,
});

export const LABEL_QUE_GET_WARNING_AND_ERROR_REQUEST = 'LABEL_QUE_GET_WARNING_AND_ERROR_REQUEST';
export const labelQueGetWarningAndErrorRequest = (batchId) => ({
  type: LABEL_QUE_GET_WARNING_AND_ERROR_REQUEST,
  batchId,
});

export const LABEL_QUE_GET_WARNING_AND_ERROR_SUCCESS = 'LABEL_QUE_GET_WARNING_AND_ERROR_SUCCESS';
export const labelQueGetWarningAndErrorSuccess = (response) => ({
  type: LABEL_QUE_GET_WARNING_AND_ERROR_SUCCESS,
  response,
});

export const LABEL_QUE_GET_WARNING_AND_ERROR_FAILURE = 'LABEL_QUE_GET_WARNING_AND_ERROR_FAILURE';
export const labelQueGetWarningAndErrorFailure = (error) => ({
  type: LABEL_QUE_GET_WARNING_AND_ERROR_FAILURE,
  error,
});

export const LABEL_QUE_PRINT_PACKING_SLIP_START = 'LABEL_QUE_PRINT_PACKING_SLIP_START';
export const labelQuePrintPackingSlipStart = (batchId, autoPrint) => ({
  type: LABEL_QUE_PRINT_PACKING_SLIP_START,
  autoPrint,
  batchId,
});

export const LABEL_QUE_PRINT_PICK_LIST_REQUEST = 'LABEL_QUE_PRINT_PICK_LIST_REQUEST';
/**
 * @param {string} batchId
 * @returns {object}
 */
export const labelQuePrintPickListStart = (batchId) => ({
  type: LABEL_QUE_PRINT_PICK_LIST_REQUEST,
  batchId,
});

export const LABEL_QUE_PRINT_SHIPMENT_MANIFEST_REQUEST = 'LABEL_QUE_PRINT_SHIPMENT_MANIFEST_REQUEST';
export const labelQuePrintShipmentManifestStart = (batchId) => ({
  type: LABEL_QUE_PRINT_SHIPMENT_MANIFEST_REQUEST,
  batchId,
});

export const COLLAPSE_ERROR_OR_WARNING = 'COLLAPSE_ERROR_OR_WARNING';
export const collapseErrorOrWarning = (batchId) => ({
  type: COLLAPSE_ERROR_OR_WARNING,
  batchId,
});

export const ON_RETRY_BATCH_REQUEST = 'ON_RETRY_BATCH_REQUEST';
export const retryBatch = (batchId) => ({
  type: ON_RETRY_BATCH_REQUEST,
  batchId,
});

export const LABEL_QUE_PRINT_ORDER_SUMMARY = 'LABEL_QUE_PRINT_ORDER_SUMMARY';
export const labelQuePrintOrderSummary = (batchId) => ({
  type: LABEL_QUE_PRINT_ORDER_SUMMARY,
  batchId,
});
